const styles = theme => ({
  '@font-face': [
    {
      fontFamily: 'LUI icons',
      src: 'url(assets/fonts/lui-icons.woff) format("woff"), url(assets/fonts/lui-icons.ttf) format("truetype")',
    },
  ],
  '@global': {
    body: {
      fontFamily: 'Inter',
      fontSize: theme.fontSize,
      margin: '0',
    },
    '.lui-dialog__footer': {
      height: 'auto !important',
    },
    '.lui-dialog-container': {
      padding: '0px',
    },
  },
  main: theme.container,
  intro: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    gap: '10px',
  },
  introText: {
    maxWidth: '50%',
    '& p': {
      fontSize: '1.1em',
      color: '#414141',
    },
  },
  reportTypeSelector: {
    '& label': {
      color: '#414141',
      fontWeight: 'bold',
      fontSize: '1em',
      '&.Mui-focused': {
        color: '#414141',
      },
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '1em',
      color: '#414141',
    },
    '& .MuiFormControlLabel-root': {
      height: '30px',
    },
    '& .Mui-checked': {
      color: `${theme.qlikGreen} !important`,
    },
  },
  sectionTitle: {
    color: '#009845',
    fontWeight: 'normal',
    fontSize: theme.fontSize * 2,
    marginTop: theme.fontSize * 2,
    marginBottom: theme.fontSize,
  },
  title: {
    color: '#63AC1F',
    fontWeight: 'normal',
    fontSize: theme.fontSize * 1.5,
    marginBottom: 0,
  },
  sectionDescription: {
    marginBottom: theme.fontSize * 1.5,
  },
  button: {
    background: 'orange',
    color: 'white',
    border: 0,
    padding: theme.fontSize,
    cursor: 'pointer',
  },
  section: {
    '&:not(:first-child)': {
      marginTop: theme.spacing,
      marginBottom: theme.spacing * 2,
      // borderTop: '1px solid #ccc',
    },
  },
  tableAndFilters: {
    // display: 'flex',
    // flexWrap: 'wrap',
    // marginTop: theme.spacing,
    display: 'flex',
    // flexWrap: 'wrap',
    alignItems: 'stretch', // Ensures children have the same height
    gap: '15px',
    height: '100vh', // Adjust this height as needed based on your layout
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 240,
    overflow: 'auto',
    marginTop: '39px',
  },
  formGroup: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formContainer: {
    width: `calc(50% - ${theme.spacing * 4}px)`,
    marginRight: theme.spacing * 2,
    '&:not(:last-child)': {
      borderRight: '1px solid #ccc',
    },
    '@media (max-width: 767px)': {
      width: '100%',
      margin: 0,
      '&:not(:last-child)': {
        borderRight: 'none',
        borderBottom: '1px solid #ccc',
        paddingBottom: theme.spacing * 2,
      },
    },
  },
  reportFromContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flexDirection: 'row',
    gap: '10px',
    backgroundColor: '#F9F9F9',
    padding: '5px 20px',
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F9F9F9',
    padding: '10px 20px',
  },
  topBarSelects: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
  },
  topBarSelect: {
    width: '200px',
  },
  footer: {
    padding: '20px 0',
    borderTop: '1px solid #AAAAAA',
    '& p': {
      color: '#767676',
      fontSize: '0.9em',
    },
  },
  sideBarFilter: {
    backgroundColor: '#F9F9F9',
    padding: '10px',
    marginBottom: '10px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  sidebarSearch: {
    backgroundColor: '#F9F9F9',
    padding: '10px',
    marginBottom: '10px',
    // width: '100%',
  },
  table: {
    flex: 1,
    overflow: 'auto',
    background: '#FFFFFF',
    // padding: '0 10px',
  },
  optionSelect: {
    color: '#7a7a7a',
    fontStyle: 'italic',
    fontSize: '13px',
    marginBottom: '5px',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  loaderIcon: {
    width: '50px',
    height: '50px',
    border: '4px solid #ccc',
    borderTop: '4px solid #009845', // Qlik green for loader color
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  '@media (max-width: 767px)': {
    intro: {
      display: 'flex',
      flexDirection: 'column',
    },
    reportFromContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    introText: {
      maxWidth: '100%',
    },
    topBarSelects: {
      display: 'flex',
      flexDirection: 'column',
    },
    tableAndFilters: {
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      marginTop: '40px',
    },
    table: {
      flex: 'initial',
      height: '700px',
    },
    filtersContainer: {
      width: '100%',
    },
  },
});


export default styles;
